/**
 * Toast viewport.
 *
 * `aria-live="polite"` announces messages without interrupting whatever the
 * user is doing.
 */

import { useUiStore } from '../../stores/uiStore.js';
import styles from './ToastViewport.module.css';

export function ToastViewport() {
  const toasts = useUiStore((state) => state.toasts);
  const dismissToast = useUiStore((state) => state.dismissToast);

  if (toasts.length === 0) return null;

  return (
    <div className={styles.viewport} aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <div key={toast.id} className={`${styles.toast} ${styles[toast.tone] ?? ''}`} role="status">
          <p className={styles.message}>{toast.message}</p>

          {toast.action && (
            <button type="button" className={styles.action} onClick={toast.action.onClick}>
              {toast.action.label}
            </button>
          )}

          <button
            type="button"
            className={styles.dismiss}
            onClick={() => dismissToast(toast.id)}
            aria-label="Dismiss notification"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
}
